import React from 'react';
import {
  Box,
  Typography,
  Button,
  Stack,
  useTheme,
  useMediaQuery,
} from '@mui/material';

const SolarSubsidyBanner = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.lighter,
        display: 'flex',
        textAlign: 'center',
        position: 'relative',
        justifyContent: 'center',
        left: '50%',
        right: '50%',
        width: '100vw',
        transform: 'translateX(-50%)',
        py: 2,
      }}
    >
      <Stack
        maxWidth='1024px'
        spacing={isMobile ? 1 : 2}
        p={isMobile ? 2 : 4}
        alignItems='center'
      >
        <Typography
          variant={isMobile ? 'h5' : 'h2'}
          fontWeight='bold'
          pb={isMobile ? 1 : 2}
        >
          Lock in 2026 rooftop solar subsidy for your home today
        </Typography>
        <Typography variant={isMobile ? 'body1' : 'h4'}>
          Claim up to ₹78,000 per connection under MNRE
          {!isMobile && <br />}
          {isMobile && ' '}
          plus state rebates
        </Typography>
        <Button
          sx={{
            textTransform: 'none',
          }}
          variant='contained'
          color='success'
          onClick={() => {
            window.open(
              'https://www.vaysolar.com/docs/blog/rooftop-solar-subsidies-india-2025/',
              '_blank',
            );
          }}
        >
          2026 subsidy details
        </Button>
      </Stack>
    </Box>
  );
};

export default SolarSubsidyBanner;
